import React from "react";

const privacy = () => {
  return (
    <div>
      <h2>PRIVACY POLICY</h2>
      <p>
        Your privacy is important to us. It is Junaid Jamshed (Pvt.)
        Ltd's policy to respect your privacy regarding any information
        we may collect from you across our website,
        http://www.junaidjamshed.com/, and other sites we own and
        operate
      </p>
      privacy
      <h2>THE INFORMATION WE MAY COLLECT </h2>
      <p>
        We may collect and process the following types of personal
        information:
      </p>
      <ul>
        <li>
          Personal contact details such as name, title, address, email
          address and telephone number as part of orders & account
          signup.
        </li>
        <li>Details of purchases and transactions</li>
        <li>Information submitted as part of a survey</li>
        <li>
          Records of correspondence with you by telephone, email, live
          chat, social media or otherwise
        </li>
        <li>
          Details of your visits to the website, and information about
          how your device has interacted with Details of your visits
          to the website, and information about how your device has
          interacted with our website, including search and browsing
          history, the pages accessed and links clicked our website,
          including search and browsing history, the pages accessed
          and links clicked
        </li>
        <li>
          Information collected automatically from your device,
          including IP address, device type, operating system, unique
          device identification numbers, browser-type, broad
          geographic location (e.g. country or city-level location)
          and other technical information
        </li>
      </ul>
      <h2>HOW YOUR DATA IS COLLECTED</h2>
      <p>
        We collect data from you when you register an account with us,
        subscribe to marketing communications from us, submit
        inquiries to us and/or purchase from us. We also collect
        information that you provide voluntarily to our customer
        services team, whether in writing, by telephone, email or live
        chat.
        <br />
        <br />
        We also collect some information automatically using cookies
        to improve the shopping experience. By using our website you
        agree that we can place these types of cookies on your device
        and access them when you visit the site in the future.
      </p>

      <h2>USE OF DATA & INFORMATION</h2>
      <p>We may collect, hold, use and disclose information for the following purposes and personal 
          information will not be further processed in a manner that is incompatible with these 
          purposes:</p>
          <ul>
              <li>To enable you to customize or personalize your experience of our website</li>
          <li>To process any transactional or ongoing payments</li>
          <li>To fulfill any orders placed with us</li>
          <li>To process refunds</li>
          <li>To create an account for you</li>
          <li>To contact and communicate with you</li>
          <li>For analytics, market research, and business development, including to
               operate and improve our website, associated applications and associated social media platforms</li>
          <li>o notify you about changes to our service</li>
          <li>To obtain and analyze your feedback as part of customer surveys</li>
          <li>o handle any disputes which we may have with you</li></ul>
          <h2>HOW WE SECURE YOUR DATA</h2>
          <p>We have put in place the necessary and appropriate safeguards and access controls to ensure the security, integrity, and privacy of the information you provide us with. Our website uses a Secure Socket Layer (SSL) 
              encryption which encrypts your information to protect it from unauthorized use.</p>
              <p>No payment details are stored on our website. we receive encrypted information needed to verify and authorize your payment and 
                  to process your order</p>
                  <h2>WHO WE MAY SHARE YOUR DATA WITH</h2>
                  <p>We may share some of your
                       data with, or obtain personal information from, the following third parties:</p>
                       <h5>Service providers</h5>
                       <p>Third party service providers for the purpose of enabling them to provide their services, including (without limitation) IT service providers, data storage, web hosting, and server providers, debt collectors, maintenance or problem-solving providers, marketing or advertising providers, professional advisors, and payment systems operators;
sponsors or promoters of any competition we run.</p>
<p>Third parties, including agents or sub-contractors, who assist us in providing information, products, services or direct marketing to you; and
third parties to collect and process data.</p>
<h5>Police or other regulatory or government authority</h5>
<p>courts, tribunals, regulatory authorities, and law enforcement officers, as required by law, in connection with any actual or 
    prospective legal proceedings, or in order to establish, exercise or defend our legal rights</p>

    <h2>CHANGES TO THIS POLICY</h2>
    <p>At our discretion, we may change our privacy policy to reflect current acceptable practices. We will take reasonable steps to let users know about changes via our website. Your continued use of this site after any changes to this policy will be regarded as acceptance of our practices around privacy and personal information.
If we make a significant change to this privacy policy, for example changing a lawful basis on which we process your personal information, we will ask you to re-consent to the amended privacy policy.</p>
<h2>CONTACT DETAILS</h2>
<p>For any questions about this policy or information requests please email eshop@junaidjamshed.com </p>

    </div>
  );
};

export default privacy;
